import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TabNavigationComponent } from './tab-navigation.component';

@NgModule({
  declarations: [TabNavigationComponent],
  imports: [CommonModule],
  exports: [TabNavigationComponent]
})
export class TabNavigationModule {}
